import {Injectable} from '@angular/core';
import {FormDefinitionFieldModel} from "../../../api/entity/formDefinitionField.model";
import {FormDefinitionFieldDataService} from "./formDefinitionFieldData.service";
import {FormDefinitionFieldConverter} from "../../../api/entity/converter/formDefinitionField.converter";
import {AbstractDataServiceDtoAdapter} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";

@Injectable()
export class FormDefinitionFieldDataServiceAdapter extends AbstractDataServiceDtoAdapter<FormDefinitionFieldModel, FormDefinitionFieldConverter> {
    constructor(dataService: FormDefinitionFieldDataService, converter: FormDefinitionFieldConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): FormDefinitionFieldModel {
        return new FormDefinitionFieldModel();
    }


}
